var cov_1395cx3cq0 = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/utils/transform.ts",
      hash = "dfc8577600d9748ff58316d107c59e626ec6dd23",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/utils/transform.ts",
    statementMap: {
      "0": {
        start: {
          line: 4,
          column: 2
        },
        end: {
          line: 4,
          column: 39
        }
      },
      "1": {
        start: {
          line: 4,
          column: 30
        },
        end: {
          line: 4,
          column: 39
        }
      },
      "2": {
        start: {
          line: 5,
          column: 26
        },
        end: {
          line: 5,
          column: 28
        }
      },
      "3": {
        start: {
          line: 6,
          column: 13
        },
        end: {
          line: 6,
          column: 23
        }
      },
      "4": {
        start: {
          line: 7,
          column: 2
        },
        end: {
          line: 7,
          column: 31
        }
      },
      "5": {
        start: {
          line: 7,
          column: 22
        },
        end: {
          line: 7,
          column: 31
        }
      },
      "6": {
        start: {
          line: 8,
          column: 2
        },
        end: {
          line: 8,
          column: 10
        }
      },
      "7": {
        start: {
          line: 12,
          column: 2
        },
        end: {
          line: 12,
          column: 39
        }
      },
      "8": {
        start: {
          line: 16,
          column: 2
        },
        end: {
          line: 16,
          column: 41
        }
      }
    },
    fnMap: {
      "0": {
        name: "mapToArray",
        decl: {
          start: {
            line: 3,
            column: 9
          },
          end: {
            line: 3,
            column: 19
          }
        },
        loc: {
          start: {
            line: 3,
            column: 52
          },
          end: {
            line: 9,
            column: 1
          }
        },
        line: 3
      },
      "1": {
        name: "keysToArray",
        decl: {
          start: {
            line: 11,
            column: 16
          },
          end: {
            line: 11,
            column: 27
          }
        },
        loc: {
          start: {
            line: 11,
            column: 50
          },
          end: {
            line: 13,
            column: 1
          }
        },
        line: 11
      },
      "2": {
        name: "valuesToArray",
        decl: {
          start: {
            line: 15,
            column: 16
          },
          end: {
            line: 15,
            column: 29
          }
        },
        loc: {
          start: {
            line: 15,
            column: 62
          },
          end: {
            line: 17,
            column: 1
          }
        },
        line: 15
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 4,
            column: 2
          },
          end: {
            line: 4,
            column: 39
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 4,
            column: 2
          },
          end: {
            line: 4,
            column: 39
          }
        }, {
          start: {
            line: 4,
            column: 2
          },
          end: {
            line: 4,
            column: 39
          }
        }],
        line: 4
      },
      "1": {
        loc: {
          start: {
            line: 4,
            column: 6
          },
          end: {
            line: 4,
            column: 28
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 4,
            column: 6
          },
          end: {
            line: 4,
            column: 10
          }
        }, {
          start: {
            line: 4,
            column: 14
          },
          end: {
            line: 4,
            column: 28
          }
        }],
        line: 4
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

function mapToArray(map, api) {
  cov_1395cx3cq0.f[0]++;
  cov_1395cx3cq0.s[0]++;

  if ((cov_1395cx3cq0.b[1][0]++, !map) || (cov_1395cx3cq0.b[1][1]++, map.size === 0)) {
    cov_1395cx3cq0.b[0][0]++;
    cov_1395cx3cq0.s[1]++;
    return [];
  } else {
    cov_1395cx3cq0.b[0][1]++;
  }

  var v = (cov_1395cx3cq0.s[2]++, []);
  var it = (cov_1395cx3cq0.s[3]++, map[api]());
  cov_1395cx3cq0.s[4]++;
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = it[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var i = _step.value;
      cov_1395cx3cq0.s[5]++;
      v.push(i);
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator["return"] != null) {
        _iterator["return"]();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  cov_1395cx3cq0.s[6]++;
  return v;
}

export function keysToArray(map) {
  cov_1395cx3cq0.f[1]++;
  cov_1395cx3cq0.s[7]++;
  return mapToArray(map, 'keys');
}
export function valuesToArray(map) {
  cov_1395cx3cq0.f[2]++;
  cov_1395cx3cq0.s[8]++;
  return mapToArray(map, 'values');
}